<template>
  <div class="container-fluid">
    <div class="KnowledgeContent col-10 offset-1">
      <h2>1. DESKI DĘBOWE WARSTWOWE</h2>
      <p>
        Deska Dębowa klejona (dwuwarstwowa), która przy zachowaniu charakteru
        drewna dębu ma niezwykłe parametry odpornościowe. Deski warstwowe można
        montować na ogrzewanie podłogowe. Składa się z dębowej warstwy
        wierzchniej o grubości 4 lub 6 mm oraz podkładu z sklejki brzozowej lub
        lamelek dębowych. W przeciwieństwie do desek trójwarstwowych, gdzie w
        podkładzie występuje i gorsze pod względem parametrów drewno iglaste, w
        tym przypadku mamy połączenie drewna szlachetnego liściastego z
        liściastym podkładem, co daje największą odporność na zmiany
        wilgotności.
      </p>
      <p><strong>Dostępne wymiary:</strong></p>
      <p><strong>Grubość:</strong> 13/4 mm; 15/6 mm</p>
      <p><strong>Szerokość:</strong> 130 mm, 150 mm, 170 mm, 190 mm</p>
      <p>
        <strong>Długości:</strong> Proporcjonalny mix długości od 600 mm – 1800
        mm
      </p>
      <div class="col-10  offset-1 woodSlice">
        <b-img
          slot="entrySectionImage"
          fluid
          alt="Responsive image"
          :src="require('../../assets/knowledge/Deska-Warstwowa-1.jpg')"
        />
        <p>Przekrój deski warstwowej</p>
      </div>
      <h2 v-scrollanimation>2. DESKI DĘBOWE LITE</h2>
      <p v-scrollanimation>
        Deska Dębowa wykonana w całości z szlachetnego drewna dębowego. Produkt
        w 100% ekologiczny. Jej wielkim atutem jest to, że stanowi izolacje
        cieplną jak również akustyczną podłoża. Nie można stosować jej na
        ogrzewanie podłogowe, jednak świetnie nadaje się nie tylko do klejenia
        na posadzkę, ale również do montażu na tzw. „legarach”.
      </p>

      <p v-scrollanimation><strong>Dostępne wymiary:</strong></p>

      <p v-scrollanimation><strong>Grubość:</strong> 16 mm; 20 mm; 22 mm</p>

      <p v-scrollanimation>
        <strong>Szerokość:</strong> 120 mm, 140 mm, 160 mm
      </p>

      <p v-scrollanimation>
        <strong>Długości:</strong> Proporcjonalny mix długości od 500 mm – 2000
        mm; Proporcjonalny mix długości od 500 mm – 1400 mm; Proporcjonalny mix
        długości od 1400 – 2000 mm;
      </p>
      <div v-scrollanimation class="col-10 offset-1 woodSlice">
        <b-img
          slot="entrySectionImage"
          fluid
          alt="Responsive image"
          :src="require('../../assets/knowledge/deska-lita.jpg')"
        />
        <p>Przekrój deski litej</p>
      </div>
      <h2 v-scrollanimation>3. KLASY JAKOŚCI</h2>
      <p v-scrollanimation>
        <strong>Rustical</strong> – Bardzo urozmaicona barwa i struktura drewna,
        mocne zabarwienia, dopuszczalne zdrowe sęki do średnicy 35 mm z
        zaprawionymi pęknięciami i ubytkami, dopuszczalne jasne i czarne sęki
        bez ograniczeń, dopuszczalnie sporadycznie występujący biel.
      </p>
      <p v-scrollanimation>
        <strong>Standard</strong> – Bardzo urozmaicona barwa i struktura drewna,
        mocne zabarwienia, dopuszczalne zdrowe sęki o średnicy 25 mm z
        zaprawionymi małymi pęknięciami, dopuszczalne czarne sęki o średnicy 5
        mm, dopuszczalnie sporadycznie występujący biel.
      </p>
      <p v-scrollanimation>
        <strong>Natural</strong> – Naturalna barwa i struktura, dowolny układ
        słojów, dopuszczalne pojedyńcze jasne sęki do średnicy 10 mm z małymi
        pęknięciami (1 szt/mb), niedopuszczalny biel, dopuszczalne szerokie
        promienie drzewne (błyszcz).
      </p>

      <div
        v-scrollanimation
        class="col-10 offset-1 woodType container-fluid"
        style="background-color:#fff"
      >
        <div v-scrollanimation>
          <b-img
            slot="entrySectionImage"
            fluid
            alt="Responsive image"
            :src="require('../../assets/knowledge/Rustical.jpg')"
          />
          <p>Rustical</p>
        </div>
        <div v-scrollanimation>
          <b-img
            slot="entrySectionImage"
            fluid
            alt="Responsive image"
            :src="require('../../assets/knowledge/Standard.jpg')"
          />
          <p>Standard</p>
        </div>
        <div v-scrollanimation>
          <b-img
            slot="entrySectionImage"
            fluid
            alt="Responsive image"
            :src="require('../../assets/knowledge/Natural.jpg')"
          />
          <p>Natural</p>
        </div>
      </div>
      <h2 v-scrollanimation>4. Montaż</h2>
      <p v-scrollanimation>
        Montaż podłóg zlecamy tylko profesjonalnym firmom parkieciarskim. Deski
        podłogowe muszą być sprawdzone pod względem ilościowym i jakościowym
        przed przytwierdzeniem do podłoża, nie należy montować desek nie
        odpowiadających oczekiwaniom, bo może to spowodować utratą gwarancji z
        tytułu zamontowanych wadliwych desek. Przed układaniem należy koniecznie
        sprawdzić deski pod względem jakościowym, sprawdzić wytrzymałość oraz
        wilgotność podłoża: podłoże betonowe do 2% wilgotności, podłoże
        drewniane 8%, podłoże anhydrytowe 0,5% . Wszelkie prace budowlane
        (mokre) powinny być zakończone. Do klejenia stosujemy kleje
        poliuretanowe 1- lub 2- składnikowe, aby uniknąć niespodzianek z tytułu
        „pracy drewna”.<br />
        Należy pamiętać o dylatacjach przy ścianach, przy większych
        powierzchniach i innych na stałe zamontowanych elementach.Należy
        pamiętać, że jest to produkt w 100% naturalny, wykonany z litego drewna,
        dlatego w miarę możliwości musimy zagwarantować mu optymalne warunki
        dotyczące temperatury i wilgotności w pomieszczeniach, gdzie będzie
        przechowywany oraz układany:
      </p>
      <p v-scrollanimation>
        <strong>temperatura powietrza:</strong> 18-23oC<br />
        <strong>wilgotność powietrza:</strong> 45-65%
      </p>
      <p v-scrollanimation>
        Są to parametry, które są też najbardziej wskazane dla człowieka.
        Najtrudniejszym okresem, w którym wilgotność powietrza znacznie spada
        jest sezon zimowy i wówczas należy nawilżać pomieszczenia, najlepiej za
        pomocą nawilżaczy, pojemników na wodę na kaloryferach oraz dbać o
        utrzymanie właściwej temperatury.
      </p>
      <h2 v-scrollanimation>5. Pielęgnacja</h2>
      <p v-scrollanimation>
        Podłogi olejowane i woskowane dają naturalnie piękne efekty
        kolorystyczne, jednak aby zachować ten stan niezbędna jest ich
        pielęgnacja. Stosowanie odpowiednich środków polecanych przez producenta
        jest bardzo ważne, ponieważ daje gwarancje sukcesu i braku problemów,
        które mogą powstać w wyniku używania tanich zamienników. Wszystkie
        opisane poniżej środki są dostępne do zakupu u nas lub w salonach
        podłóg.
      </p>
      <p v-scrollanimation><strong>Pielęgnacja całościowa</strong></p>
      <p v-scrollanimation>
        Pierwsze zastosowanie pielęgnacji zalecamy po około 2 tygodniach od jej
        montażu. W tym wypadku stosujemy produkt przeznaczony specjalnie dla
        naszych podłóg. Jest to Saicos WaxCare. Stosuje się go na całości
        podłogi, a rozprowadza dokładnie szmatką lub maszynowo padem. Następnie
        powierzchnie polerujemy suchą szmatką. Jest to bardzo intuicyjne i
        proste. Ważne jest, żeby pokryć równomiernie całą powierzchnie, a
        następnie odczekać przed wejściem na deski około 2 godzin. Taką
        pielęgnacje stosujemy w zależność od potrzeb oraz bieżącego wyglądu
        podłogi. Środek WaxCare uzupełnia braki w wierzchniej warstwie wosku,
        więc własnie do tego jest przeznaczony.
      </p>
      <p v-scrollanimation><strong>Pielęgnacja codzienna</strong></p>
      <p v-scrollanimation>
        Codzienne dbanie o podłogi olejo-woskowane jest bardzo proste, jednak
        jest kilka zasad, które należy przestrzegać, aby cieszyć się swoimi
        deskami przez długie lata.
      </p>
      <ul v-scrollanimation>
        <li>
          Podłogi nie należy myć żadnymi ostrymi środkami, przeznaczonymi do
          podłóg lakierowanych czy innych powierzchni (kafelki, panele etc.)
        </li>
        <li>
          Do codziennego mycia naszych desek zalecamy środek Saicos WashCare.
          Idealnie usuwa zabrudzenia, a dodatkowo chroni deski i konserwuje je.
          Jest bardzo wydajny (miesza się go z wodą). Jeśli podłogi myte są
          często, nie ma potrzeby używania go za każdym razem. Najlepiej wtedy
          używać po prostu wody.
        </li>
        <li>
          Podłogi nie powinno się myć wcześniej, niż 21 dni od montażu. Wosk
          utwardza się około 3 tygodni, a mycie go poprzez wycieranie podłogi,
          może skutkować jego ubytkami
        </li>
        <li>
          Nasze podłogi są naturalnymi dębowymi podłogami, które są jak każde
          drewno wrażliwe na wilgoć i wodę. Należy więc zachować ostrożność, aby
          w trakcie mycie nie zostawiać zbyt dużej ilości wody na deskach.
        </li>
        <li>
          Do mebli stosujemy podkładki filcowe, a pod obrotowe krzesła stosujemy
          podkładki w celu uniknięcia zarysowań
        </li>
        <li>
          Należy zadbać o system zbierania brudu i błota (wycieraczki oraz maty)
        </li>
        <li>Na bieżąco należy usuwać piasek z powierzchni deski.</li>
      </ul>
      <p v-scrollanimation><strong>Pielęgnacja trudnych zabrudzeń</strong></p>
      <p v-scrollanimation>
        W przypadku trudnych lub nietypowych zabrudzeń należy użyć specjalnego
        środka do ich usunięcia, tj. Saicos MagicCleaner. Należy nałożyć środek
        na zabrudzone miejsce, a następnie szmatką lub padem spróbować usunąć
        zabrudzenie. Jeśli osiągnęliśmy sukces, ale w miejscu zabrudzenia,
        podłoga wygląda na &#8222;przetartą&#8221; należy zastosować miejscowo
        środek WaxCare, aby ukryć różnice. MagicCleaner można stosować również
        całościowo w celu odświeżenie podłogi, a następnie zabezpieczyć ją przed
        zabrudzeniami WaxCare.
      </p>
      <p v-scrollanimation><strong>Sytuacje nietypowe</strong></p>
      <p v-scrollanimation>
        W przypadku wystąpienia zabrudzeń, które nie chcą się usunąć przy pomocy
        wyżej opisanych metod, mechaniczne zarysowania, odbicia lub jakiekolwiek
        ubytki, których nie jesteście w stanie Państwo naprawić sami używając
        wyżej opisanych metod, należy się zwrócić o pomoc do salonu, firmy
        parkieciarskiej lub do nas bezpośrednio, a my jako fachowcy postaramy
        się znaleźć sposób na rozwiązanie Państwa problemu.
      </p>
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style scoped>
.KnowledgeContent {
  display: flex;
  flex-direction: column;
  background-color: #fff;
}
p,
li,
h2 {
  text-align: left;
}
h2 {
  margin-top: 2%;
}

.woodType {
  display: flex;
  flex-direction: row;
}
.woodType div {
  margin: 2%;
}
.woodType p {
  text-align: center;
}
.woodSlice p {
  text-align: center;
}
.container-fluid {
  background-color: #eee;
}
@media (max-width: 600px) {
  .woodType {
    flex-direction: column;
  }
}
</style>
